import { render, staticRenderFns } from "./visit-person-case-manage.vue?vue&type=template&id=ea983c3a&scoped=true"
import script from "./visit-person-case-manage.vue?vue&type=script&lang=ts"
export * from "./visit-person-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea983c3a",
  null
  
)

export default component.exports